import type { ContentChangeListener } from '@oneaudi/content-service';
import type { ContentServiceV1 } from '../../types/feature-service-types';
import type { ReactElement } from 'react';
import React, { useState } from 'react';
import type { Logger } from '@feature-hub/logger';
import type { CardsData } from '../../types/shared';
import { ContentContext } from './ContentContext';
import type { EditorJsonContent, FalconContent } from './ContentInterfaces';

const mapHeadlessContent = (content: FalconContent): CardsData => {
  const { displayIcons, cards } = content.fields;

  const appContent: CardsData = {
    displayIcons,
    cards: cards.map((card) => ({ ...card.fields })),
  };
  return appContent;
};

const mapFaceContent = (content: EditorJsonContent): CardsData => {
  const appContent: CardsData = {
    ...content,
    cards: Array.isArray(content.cards) ? content.cards : [],
  };
  return appContent;
};

export const ContentContextProvider: React.FC<{
  contentService: ContentServiceV1;
  loggerService?: Logger;
  children?: ReactElement;
}> = ({ contentService, children, loggerService }) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [rawContent, setRawContent] = useState(contentService.getContent());
  contentService.onContentChange(setRawContent as ContentChangeListener);
  let content: CardsData;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (rawContent?.__type === 'aem-headless') {
    const falconContent = rawContent as FalconContent;
    content = mapHeadlessContent(falconContent);
    loggerService?.info('aem-headless-content:', falconContent);
  } else if (rawContent) {
    const editorJsonContent = rawContent as EditorJsonContent;
    content = mapFaceContent(editorJsonContent);
  } else {
    content = { cards: [], displayIcons: false };
  }

  return (
    <ContentContext.Provider value={{ content, loggerService }}>{children}</ContentContext.Provider>
  );
};

ContentContextProvider.displayName = 'ContentContextProvider';
